import { rem } from 'polished';
import styled from 'styled-components';
import Container from '@/components/Global/Container';

export const InfoCardsWrapper = styled(Container)`
  background-color: #fff;
  text-align: center;
  padding-top: ${rem('40px')};
  padding-bottom: ${rem('40px')};
`;

export const Spacer = styled.div<{ gapHeight: string }>`
  height: ${props => props.gapHeight};
  background-color: transparent;
  color: transparent;
  width: 100%;
`;
